import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Performers from "./pages/Performers";
import Vendors from "./pages/Vendors";
import SponsorsSupporters from "./pages/SponsorsSupporters";
import Organizations from "./pages/Organizations";
import Competitions from "./pages/Competitions";
import Gallery from "./pages/Gallery";
import Etiquette from "./pages/Etiquette";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/performers" element={<Performers />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/sponsors-supporters" element={<SponsorsSupporters />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/competitions" element={<Competitions />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/etiquette" element={<Etiquette />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
